export const onPhoneNumberChanged = (value: string) => {
  const onlyNums = value.replace(/[^0-9]/g, '')
  let isValid = false
  let phone = ''

  if (onlyNums.length <= 10) {
    isValid = true
    if (onlyNums.length > 6) {
      phone = onlyNums.replace(/(\d{3})(\d{3})(\d)/, '$1-$2-$3')
    } else if (onlyNums.length > 3) {
      phone = onlyNums.replace(/(\d{3})(\d)/, '$1-$2')
    } else {
      phone = onlyNums
    }
  }
  return {
    isValid,
    phone,
  }
}
